import React, { useState, useContext, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import bg2 from "./Images/bg2.jpg";
import PermissionContext from "../../Store/permission-context";
import { Divider } from "rsuite";
import logoutIcon from "./Images/logoutIcon.png";
import backupIcon from "./Images/backupIcon.png";
import inventoryIcon from "./Images/inventoryIcon.png";
import registeredCustomerIcon from "./Images/registeredCustomerIcon.png";
import salesreportIcon from "./Images/salesreportIcon.png";
import supplyreportIcon from "./Images/supplyreportIcon.png";
import addstockIcon from "./Images/addstockIcon.png";
import goodssummaryIcon from "./Images/goodssummaryIcon.png";
import salesIcon from "./Images/salesIcon.jpg";
import expensesIcon from "./Images/expensesIcon.png";
import newuserIcon from "./Images/newuserIcon.png";
import viewdebtIcon from "./Images/viewdebtIcon.png";
import viewuserIcon from "./Images/viewuserIcon.png";
import gethistoryIcon from "./Images/gethistoryIcon.png";
import changepasswordIcon from "./Images/changepasswordIcon.png";
import changepriceIcon from "./Images/changepriceIcon.png";
import myreportIcon from "./Images/myreportIcon.png";
import updateserverIcon from "./Images/updateserverIcon.png";
import classes from "./MenuPageDisplay.module.css";
import Cookies from "universal-cookie";
import ExpiredAlert from "./Images/ExpiryAlert.mp3";
import NewNotification from "./NewNotification";
const MenuDisplayPage = () => {
  const PCtx = useContext(PermissionContext);
  const cookies = new Cookies();
  var CryptoJS = require("crypto-js");
  const audioFile = new Audio(ExpiredAlert);
  const [AxiosError, setAxiosError] = useState("");
  const decryption = (Scramb) => {
    let Permission = false;
    if (PCtx.logged) {
      // Scramb = "U2FsdGVkX1/WscdZ+9IV7bHNnXe+9Ptb9Fcv1faThVI=";
      let Scrambled = Scramb.replace(/\s/g, "");
      var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
      let Allowance = bytes.toString(CryptoJS.enc.Utf8);
      Permission = parseInt(Allowance) === 1 ? true : false;
    }
    return Permission;
  };
  const [ThereIsExpiredProducts, setThereIsExpiredProducts] = useState(
    PCtx.Expired,
  );
  const [isExpired, setisExpired] = useState(false);
  const [AllMenu, setAllMenu] = useState([
    {
      Name: "New Sales",
      Picture: salesIcon,
      Action: decryption(PCtx.NS)
        ? PCtx.RealPath + "/sales"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "My Report",
      Picture: myreportIcon,
      Action: decryption(PCtx.MR)
        ? PCtx.RealPath + "/myreport"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Add Stock",
      Picture: addstockIcon,
      Action: decryption(PCtx.SI)
        ? PCtx.RealPath + "/supplyin"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Change Price",
      Picture: changepriceIcon,
      Action: decryption(PCtx.CP)
        ? PCtx.RealPath + "/changeprice"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Add Staff/Customer",
      Picture: newuserIcon,
      Action: decryption(PCtx.ASt)
        ? PCtx.RealPath + "/addnewuser"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "View Staff",
      Picture: viewuserIcon,
      Action: decryption(PCtx.VS)
        ? PCtx.RealPath + "/viewusers"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Change Password",
      Picture: changepasswordIcon,
      Action: decryption(PCtx.CPw)
        ? PCtx.RealPath + "/changepassword"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Sales Report",
      Picture: salesreportIcon,
      Action: decryption(PCtx.SR)
        ? PCtx.RealPath + "/getreport"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Supply Report",
      Picture: supplyreportIcon,
      Action: decryption(PCtx.SP)
        ? PCtx.RealPath + "/getsupplyreport"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Goods Sales Summary",
      Picture: goodssummaryIcon,
      Action: decryption(PCtx.GS)
        ? PCtx.RealPath + "/goodssummary"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Inventory",
      Picture: inventoryIcon,
      Action: decryption(PCtx.IV)
        ? PCtx.RealPath + "/inventory"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Reg. Customers Report",
      Picture: registeredCustomerIcon,
      Action: decryption(PCtx.CR)
        ? PCtx.RealPath + "/customersreports"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "View Debts",
      Picture: viewdebtIcon,
      Action: decryption(PCtx.VD)
        ? PCtx.RealPath + "/viewdebts"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Record Expenses",
      Picture: expensesIcon,
      Action: decryption(PCtx.CF)
        ? PCtx.RealPath + "/cashflow"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Item History",
      Picture: gethistoryIcon,
      Action: decryption(PCtx.GH)
        ? PCtx.RealPath + "/gethistory"
        : PCtx.RealPath + "/#",
    },
    {
      Name: "Update Server",
      Picture: updateserverIcon,
      Action: decryption(PCtx.US)
        ? PCtx.RealPath + "/updateonline"
        : PCtx.RealPath + "/#",
    },
    { Name: "Back - Up", Picture: backupIcon, Action: PCtx.RealPath + "/" },
    { Name: "Log Out", Picture: logoutIcon, Action: PCtx.RealPath + "/home" },
  ]);
  let ConnectionCount = 0;

  const GetClickAction = async (nm, act) => {
    if (nm === "Log Out") {
      const Response = await PCtx.connectAxios(
        "recordlogout.php",
        PCtx.Username,
      );

      cookies.remove("logged", { path: "/" });
      cookies.remove("this_staff", { path: "/" });
      cookies.remove("ExpiredItems", { path: "/" });
      PCtx.GetCookiesValue();
      PCtx.GetCookiesValue();
      PCtx.setExpired(false);

      PCtx.displayAlert(
        "Logged Out",
        "You have been successfully logged out. Bye!",
        "success",
      );
    } else {
      if (nm == "Back - Up") {
        let theresponse = await PCtx.connectAxios("backup.php", "");

        const element = document.createElement("a");
        const file = new Blob([theresponse], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        let today = new Date().toISOString().slice(0, 10);
        element.download = "BackUp_" + today + ".sql";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        PCtx.displayAlert(
          "SUCCESS",
          "Database has been backed up successfully!",
          "success",
        );
      } else {
        if (act === PCtx.RealPath + "/#") {
          PCtx.displayAlert(
            "ACTION DENIED",
            "You are not authorised for this Menu. Contact the Administrator",
            "danger",
          );
        }
      }
    }
  };

  useEffect(() => {
    const GetExpiredGoods = async () => {
      let AllExpiredGoods = await PCtx.connectAxios("getexpiredgoods.php", "");
      console.log(PCtx.Expired);
      if (
        Array.isArray(AllExpiredGoods) &&
        AllExpiredGoods.length > 0 &&
        !PCtx.Expired
      ) {
        setisExpired(true);
        let soundCount = 0;
        const interval = setInterval(() => {
          if (soundCount < 5) {
            setThereIsExpiredProducts(
              (prevThereIsExpiredProducts) => !prevThereIsExpiredProducts,
            );
            soundCount++;
          } else {
            let d = new Date();
            d.setTime(d.getTime() + 30 * 60 * 1000);
            setThereIsExpiredProducts(true);
            PCtx.setExpired(true);
            cookies.set("ExpiredItems", "Yes", {
              path: "/",
              expires: d,
            });
            clearInterval(interval);
            let eXP = cookies.get("ExpiredItems");
          }
        }, 1000);
      } else {
        setisExpired(false);
        setThereIsExpiredProducts(false);
      }
    };
    GetExpiredGoods();
  }, []);

  useEffect(() => {
    if (ThereIsExpiredProducts && !PCtx.Expired) {
      audioFile.currentTime = 0;
      audioFile.play();
    } else {
      audioFile.currentTime = 0;
      audioFile.pause();
    }
  }, [ThereIsExpiredProducts]);

  return (
    <Row
      className="pb-3"
      style={{
        backgroundImage: `url(${bg2})`,
        backgroundSize: "cover",
      }}
    >
      <Divider className={classes.Welcomemsg}>
        Welcome {PCtx.Username},<br /> Please Pick a Menu below.
      </Divider>
      <Col>
        <Row className={isExpired ? classes.RowHeight : classes.RowHeight2}>
          <Col>{ThereIsExpiredProducts && <NewNotification />}</Col>
        </Row>
        <Row className="px-4 justify-content-around">
          {AllMenu.map((eachmenu, index) => (
            <Col
              md={2}
              sm={5}
              xs={5}
              className="px-0"
              key={index}
              style={{ marginTop: "40px" }}
            >
              <Link
                to={eachmenu.Name != "Log Out" && eachmenu.Action}
                className={classes.thelinks}
                onClick={() => GetClickAction(eachmenu.Name, eachmenu.Action)}
              >
                <Card className={classes.thecards}>
                  <Card.Body className="justify-content--around ">
                    <img src={eachmenu.Picture} className={classes.theIcons} />
                  </Card.Body>
                  <Card.Footer
                    style={{
                      paddingLeft: "0em",
                      textAlign: "center",
                      borderLeft: "3px groove brown",
                    }}
                  >
                    {eachmenu.Name}
                  </Card.Footer>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default MenuDisplayPage;
